import Cv from './cv'

const cv = {
  install: function (Vue) {
    Vue.component('Cv', Cv)
  }
}
export default cv
